import ConversionAnalysisNavBarBody from "app/components/sidebar3/secondary-side-bar/components/ConversionAnalysisNavBar/ConversionAnalysisNavBarBody";
import { ConversionAnalysisNavBarHeader } from "app/components/sidebar3/secondary-side-bar/components/ConversionAnalysisNavBar/ConversionAnalysisNavBarHeader";
import DashboardsNavBarBody from "app/components/sidebar3/secondary-side-bar/components/DashboardsNavBar/DashboardsNavBarBody";
import DashboardsNavBarHeader from "app/components/sidebar3/secondary-side-bar/components/DashboardsNavBar/DashboardsNavBarHeader";
import { DigitalSuiteGenericNavBarBody } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarBody";
import { DigitalSuiteGenericBarHeader } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarHeader";
import { segmentAnalysisNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/competition/segmentAnalysisNavObj";
import { websiteAnalysisNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/competition/websiteAnalysisNavObj";
import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";
import { monitorAndProtectNavigation } from "app/pages/digital-marketing/monitor-and-protect/app/monitor-and-protect-navigation";

import { backlinksAnalysisNavObj } from "../secondary-bar-nav-obj/search-intelligence/backlinksAnalysisNavObj";
import { keywordResearchNavObj } from "../secondary-bar-nav-obj/search-intelligence/keywordResearchNavObj";
import { searchTrackingNavObj } from "../secondary-bar-nav-obj/search-intelligence/SearchTrackingNavObj";

// market analysis sub Sections
// competitive sub Sections
const WEBSITE_ANALYSIS_STATE_ID = "digitalsuite_websiteanalysis_home";
const SEGMENT_ANALYSIS_STATE_ID = "digitalsuite_segments-homepage";
//search intelligence sub Sections
const KEYWORD_RESEARCH_STATE_ID = "organicsearch_websiteanalysis_home";
const BACKLINKS_ANALYSIS_STATE_ID = "digitalsuite_backlinks_overview";
//campaigns sub-sction
const RANK_TRACKER_ID = "ranktracker.home";
// competitive sub Sections
export const digitalSuiteWebsiteAnalysisNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={WEBSITE_ANALYSIS_STATE_ID}
                title={"digitalsuite.navbar.websiteanalysis.group"}
            />
        ),
        SecondaryBarBody: <DigitalSuiteGenericNavBarBody navObj={websiteAnalysisNavObj().navList} />,
    };
};
export const digitalSuiteSegmentAnalysisNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={SEGMENT_ANALYSIS_STATE_ID}
                title={"digitalsuite.navbar.segmentanalysis.group"}
            />
        ),
        SecondaryBarBody: <DigitalSuiteGenericNavBarBody navObj={segmentAnalysisNavObj().navList} />,
    };
};

// search intelligence sub Sections
export const digitalSuiteKeywordResearchNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={KEYWORD_RESEARCH_STATE_ID}
                title={"primary.sidebar.keyword.research.title"}
            />
        ),
        SecondaryBarBody: (
            <DigitalSuiteGenericNavBarBody
                key={KEYWORD_RESEARCH_STATE_ID}
                navObj={keywordResearchNavObj().navList}
            />
        ),
    };
};
export const digitalSuiteBacklinksAnalysisNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={BACKLINKS_ANALYSIS_STATE_ID}
                title={"primary.sidebar.backlinks.analysis.title"}
            />
        ),
        SecondaryBarBody: (
            <DigitalSuiteGenericNavBarBody
                key={BACKLINKS_ANALYSIS_STATE_ID}
                navObj={backlinksAnalysisNavObj().navList}
            />
        ),
    };
};

export const digitalSuiteSearchTrackingNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={RANK_TRACKER_ID}
                title={"primary.sidebar.search.tracking.title"}
            />
        ),
        SecondaryBarBody: (
            <DigitalSuiteGenericNavBarBody
                key={RANK_TRACKER_ID}
                navObj={searchTrackingNavObj().navList}
            />
        ),
    };
};

export const dashboardsNavBarContents = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: <DashboardsNavBarHeader />,
        SecondaryBarBody: <DashboardsNavBarBody />,
    };
};
export const conversionAnalysisNavBarContents = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: <ConversionAnalysisNavBarHeader />,
        SecondaryBarBody: <ConversionAnalysisNavBarBody />,
    };
};

// AA/PA secondary-sidebar content factories live in the app-shared nav-obj modules so that
// feature zones (e.g. `sales`) can consume them without crossing into the composition root.
// Re-exported here for the co-located `secondarySidebarMap`.
export { digitalSuiteAdvertiserActivityNavBarContent } from "../secondary-bar-nav-obj/ad-intelligence/advertiserActivityNavObj";
export { digitalSuitePublisherAnalysisNavBarContent } from "../secondary-bar-nav-obj/ad-intelligence/publisherAnalysisNavObj";

export const monitorAndProtectNavBarContent = monitorAndProtectNavigation;
